import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { loginUser, logoutUser } from '../redux/user/userSlice';
import useAuth from './useAuth';

export default function useUser(
  userId,
  search,
  paginationModel,
  sortModel,
  getAllData = false,
  showDeletedUsers,
  caseId,
  isChat
) {
  const { request } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { user } = useSelector((state) => state.user);

  const handleRefetchUsers = () => {
    queryClient.invalidateQueries({ queryKey: ['/users'] });
  };

  const userLoginMutation = useMutation({
    mutationFn: (payload) => request.post('/auth', payload).then((res) => res.data),
    onSuccess: (data) => {
      const token = data?.token || '';
      const userId = data?.user?._id;
      const role = data?.user?.role || 'ADMIN';
      if (!userId) return console.error('User ID not found');
      dispatch(loginUser({ token, userId, role }));
      navigate('/dashboard');
    },
    onError: (error) => console.error('Login error:', error),
  });

  const centerLoginMutation = useMutation({
    mutationFn: (payload) => request.post('/auth/center', payload).then((res) => res.data),
    onSuccess: (data) => {
      const token = data?.token || '';
      const userId = data?.user?._id;
      const role = data?.user?.role || 'CENTER';
      if (!userId) return console.error('User ID not found');
      dispatch(loginUser({ token, userId, role }));
      navigate('/center-dashboard');
    },
    onError: (error) => console.error('Center login error:', error),
  });

  //   const verifyOtpMutation = useMutation({
  //     mutationFn: (payload) => request.post('/auth/verifyOtp', payload).then((res) => res.data),
  //     onSuccess: (data) => {
  //       localStorage.removeItem('verifyEmail');
  //       const token = data?.token || '';
  //       if (!token) return console.error('Token not found');
  //       const userId = decoded?.id;
  //       if (!userId) return console.error('User ID not found');
  //       dispatch(loginUser({ token, userId }));
  //       navigate('/cases');
  //     },
  //     onError: (error) => console.error('Logout error:', error),
  //   });

  const userLogoutMutation = useMutation({
    mutationFn: () =>
      request.post('/auth/logout', { userId: user?.userId, isSite: true }).then((res) => res.data),
    onSuccess: () => {
      const isCenterUser = user?.role === 'CENTER';
      dispatch(logoutUser());
      localStorage.removeItem('persist:user');
      navigate(isCenterUser ? '/center-login' : '/login');
    },
    onError: (error) => console.error('Logout error:', error),
  });


  return {
    userLoginMutation: userLoginMutation.mutateAsync,
    isLoading: userLoginMutation.isPending,
    centerLoginMutation: centerLoginMutation.mutateAsync,
    isCenterLoading: centerLoginMutation.isPending,
    userLogoutMutation: userLogoutMutation.mutateAsync,
    isLoggingOut: userLogoutMutation.isPending,
  };
}
